import React, { useState, useEffect } from "react";
import SelectSearch from "react-select-search";
import moment from "moment";
import { Row, Col, FormGroup, Label, Table } from "reactstrap";

import QuestionnaireModal from "./QuestionnaireModal";
import staffService from "../../services/staffService";

const UpdateLitigantQuestionnaire = () => {
  const [selected, setSelected] = useState({ id: "0" });
  const [getUsers, setGetUsers] = useState("get");
  const [selectedLit, setSelectedLit] = useState([]);
  const [questionnaireList, setQuestionnaireList] = useState([]);
  const [users, setUsers] = useState([]);
  const [questionnaireButton, setQuestionnaireButton] = useState({
    color: "primary",
    msg: "New Questionnaire",
    id: 0,
  });
  const defaultFormState = {
    firstName: "",
    lastName: "",
    dob: moment().format("MM/DD/YYYY"),
    userName: "",
    token: "",
    tokenExp: moment().format(),
  };
  const [formState, setFormState] = useState({ ...defaultFormState });

  // useEffect(() => {
  //   staffService.getUsers().then((payload) => setUsers(payload));
  // }, []); //If we pass an empty array to useEffect, it’s only executed after the first render.
  useEffect(() => {
    if (getUsers === "get") {
      //console.log("--------");
      staffService.getUsers().then((payload) => {
        setUsers(payload);
        let renamedArray = payload.map((a) => {
          return {
            name: a.lastName + ", " + a.firstName,
            value: a.id,
            lit: { ...a },
          };
        });

        setSelectedLit(renamedArray);
      });
      setGetUsers("set");
    }
  }, [getUsers]);

  const onSelect = (id) => {
    //const { target } = evt;
    if (id) {
      setSelected({ ...selected, id: id });
      if (id !== "0") {
        let user = users.find((user) => user.id === id);
        var fs = formState;
        //console.log(fs);
        var fsu = Object.assign(fs, user);
        //console.log(fsu);
        fsu = { ...fsu, token: id };
        setFormState({ ...fsu });
        staffService
          .getAllQuestionnaires(id)
          .then((payload) => setQuestionnaireList(payload));
        return;
      }
      setFormState({ ...defaultFormState });
    }
  };

  const getQuestionnaireButton = (value) => {
    //keep just in castab
    setGetUsers("get");
    onSelect(value);
    return;
  };

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h2>View/Edit litigant questionnaires</h2>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <FormGroup row>
            <Label sm={12}>Select a user</Label>
            <Col sm={12}>
              {/* <Input
                type="select"
                name="select"
                id="exampleSelect"
                size={size.toString()}
                onChange={(e) => onSelect(e)}
              >
                <option value="0">Select a litigant</option>
                {users.map((u) => (
                  <option value={u.id} key={u.id}>
                    {u.lastName}, {u.firstName}
                  </option>
                ))}
              </Input> */}
              <SelectSearch
                options={selectedLit}
                value={selected.id}
                search={true}
                name="select"
                placeholder="Choose a litigant"
                onChange={(id) => onSelect(id)}
                printOptions="always"
              />
            </Col>
          </FormGroup>
        </Col>
        {formState.lastName !== "" && (
          <Col>
            <h3>
              {formState.lastName}, {formState.firstName}
            </h3>
            <p>
              <b>DOB:</b> {moment(formState.dob).format("MM/DD/YYYY")},{" "}
              <b>Email:</b> {formState.userName}, <b>Phone:</b>{" "}
              {formState.phoneNumber}
            </p>
            <h4>Existing questionnaires</h4>
            {questionnaireList.length === 0 && (
              <div>
                <label>No existing questionnaire</label> <br />
                {selected.id !== "0" && (
                  <QuestionnaireModal
                    buttonLabel={questionnaireButton.msg}
                    userId={selected.id}
                    qId={questionnaireButton.id}
                    color={questionnaireButton.color}
                    hasCurrentQuestionnaire={
                      parseInt(questionnaireButton.id) > 0 ? true : false
                    }
                    getQuestionnaireButton={getQuestionnaireButton}
                    modalTitle={questionnaireButton.msg}
                  />
                )}
              </div>
            )}
            {questionnaireList.length !== 0 && (
              <Table>
                <thead>
                  <tr>
                    <th>Questionnaire</th>
                    <th>Created</th>
                    <th>Appointment</th>
                    <th>Status</th>
                    <th>View/Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {questionnaireList.map((q) => (
                    <tr key={q.userQuestionnaireId}>
                      <td>{q.userQuestionnaireId}</td>
                      <td>{moment(q.createdDate).format("MM/DD/YYYY")}</td>
                      <td>
                        {q.appointmentId === 0
                          ? "None"
                          : moment(q.appointment.timeSlotStart).format(
                              "MMMM Do YYYY, h:mm a"
                            )}
                      </td>
                      <td>
                        {q.questionnaireStatus === 1
                          ? "In progress"
                          : q.questionnaireStatus === 2
                          ? "Complete"
                          : "Deleted"}
                      </td>
                      {/* <td>
                        <QuestionnaireModal
                          buttonLabel={
                            q.questionnaireStatus === 1 ? "Edit" : "View"
                          }
                          userId={q.userId}
                          qId={q.userQuestionnaireId}
                          color={
                            q.questionnaireStatus === 1 ? "primary" : "info"
                          }
                          hasCurrentQuestionnaire={
                            parseInt(q.userQuestionnaireId) > 0 ? true : false
                          }
                          modalTitle={
                            q.questionnaireStatus === 1
                              ? "Edit Questionnaire"
                              : "View Questionnaire"
                          }
                          getQuestionnaireButton={getQuestionnaireButton}
                          readOnly={q.questionnaireStatus === 1 ? false : true}
                        />
                      </td> */}
                      <td>
                        <QuestionnaireModal
                          buttonLabel="View Questionnaire"
                          color="primary"
                          userId={q.userId}
                          qId={q.userQuestionnaireId}
                          hasCurrentQuestionnaire={
                            parseInt(q.userQuestionnaireId) > 0 ? true : false
                          }
                          modalTitle={
                            q.questionnaireStatus === 1
                              ? "Edit Questionnaire"
                              : "View Questionnaire"
                          }
                          readOnly={q.questionnaireStatus === 1 ? false : true}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

export default UpdateLitigantQuestionnaire;
